import { formatMoney } from '@/lib/format';
import { vehicleLabel } from '@/lib/ride-format';
import type { RideOption } from '@/lib/rides-types';
import { LeadIcon } from '@/components/ui/lead-icon';
import { Money } from '@/components/ui/money';

/** Fare as a single price, or a min–max range when the BPP returns an estimate band. */
function fareNode(o: RideOption) {
  if (o.fareMin && o.fareMax && o.fareMin !== o.fareMax) {
    return <Money v={`${o.fareMin}–${o.fareMax}`} strong />;
  }
  return <Money v={formatMoney(o.fare).replace('₹', '')} strong />;
}

export function RideOptionCard({
  option,
  selected,
  onSelect,
}: {
  option: RideOption;
  selected: boolean;
  onSelect: () => void;
}) {
  const subtitle = [option.providerName, option.etaMinutes ? `${option.etaMinutes} min away` : null]
    .filter(Boolean)
    .join(' · ');
  const icon = option.vehicleCategory === 'AUTO_RICKSHAW' ? 'auto' : 'cab';

  return (
    <button
      type="button"
      onClick={onSelect}
      aria-checked={selected}
      className={`wb-option cat-ride ${selected ? 'is-selected' : ''}`}
    >
      <LeadIcon category="ride" icon={icon} size={40} />
      <span className="wb-grow">
        <span className="wb-strong" style={{ display: 'block' }}>
          {vehicleLabel(option.vehicleCategory, option.vehicleVariant)}
        </span>
        {subtitle && (
          <span className="wb-tiny" style={{ display: 'block' }}>
            {subtitle}
          </span>
        )}
      </span>
      {fareNode(option)}
    </button>
  );
}
